import { formatTime, safeFormatTime } from '../timeService';
import { dateTimeFormat } from '../timeService/types';
import type { CustomEventDefinitionField, CustomEventEntry } from './useCustomEventsService';

export const formatFieldValueForDisplay = (
  field: CustomEventDefinitionField,
  raw: unknown,
): string => {
  const optionLabel = (value: string) =>
    field.options?.find((option) => option.value === value)?.label ?? value;

  switch (field.type) {
    case 'select':
    case 'radio':
      return raw == null || raw === '' ? '' : optionLabel(String(raw));
    case 'checkbox':
      return Array.isArray(raw) ? raw.map((value) => optionLabel(String(value))).join(', ') : '';
    case 'date':
      return raw
        ? safeFormatTime(String(raw), dateTimeFormat.LOCAL_DATE_FORMAT, String(raw), 'UTC')
        : '';
    case 'datetime':
      return raw ? formatTime(String(raw), dateTimeFormat.DATE_TIME_FORMAT) : '';
    default:
      return raw == null ? '' : String(raw);
  }
};

export const formatEffectiveTime = (
  entry: Pick<CustomEventEntry, 'effectiveTime' | 'isDateOnly'>,
): string =>
  entry.isDateOnly
    ? formatTime(entry.effectiveTime, dateTimeFormat.LOCAL_DATE_FORMAT, 'UTC')
    : formatTime(entry.effectiveTime, dateTimeFormat.DATE_TIME_FORMAT);
